import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	httpSaveVisualVettingDraft,
	type SaveVisualVettingDraftOptions
} from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'
import { VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY } from './use-get-visual-vetting-listing-details'
import { VISUAL_VETTING_LISTINGS_QUERY_KEY } from './use-get-visual-vetting-listings'
import { VISUAL_VETTING_SCORE_QUERY_KEY } from './use-get-visual-vetting-score'

export const useSaveVisualVettingDraft = (
	listingId: string,
	options?: Omit<
		UseMutationOptions<
			unknown,
			unknown,
			SaveVisualVettingDraftOptions['payload']
		>,
		'mutationFn'
	>
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload) =>
			httpSaveVisualVettingDraft({
				urlParams: { listingId },
				payload
			}),
		...options,
		onSuccess: (...args) => {
			queryClient.invalidateQueries({
				queryKey: [VISUAL_VETTING_LISTINGS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [
					VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY,
					{ listingId }
				]
			})

			queryClient.invalidateQueries({
				queryKey: [VISUAL_VETTING_SCORE_QUERY_KEY, { listingId }]
			})
			options?.onSuccess?.(...args)
		},
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		}
	})
}
